"use client";
import React from "react";
import { useAppProps } from "~/app/_apps/AppPropsContext";
import BrandNeededWrapper from "~/components/BrandNeededWrapper.jsx";
import ReturnReasonsPage from "~/app/(pages)/settings/return-reasons/ReturnReasonsPage.jsx";

export default function ReturnReasonsPageWrapper({ ref }) {
    const { appProps } = useAppProps();

    return (
        <BrandNeededWrapper appProps={appProps}>
            <ReturnReasonsPage appProps={appProps} ref={ref} />
        </BrandNeededWrapper>
    );
}
